import { registerWebModule, NativeModule } from "expo";

class ExpoNotificationServiceExtensionModule extends NativeModule {
  configureNotificationExtension(_configJson: string): void {
    console.warn(
      "expo-notification-service-extension is not supported on web."
    );
  }
  async prefetchAvatar(_url: string, _id: string): Promise<void> {
    console.warn(
      "expo-notification-service-extension is not supported on web."
    );
  }
  async clearAvatarCache(): Promise<void> {
    console.warn(
      "expo-notification-service-extension is not supported on web."
    );
  }
  async validateSetup(_samplePayloadJson?: string): Promise<string> {
    console.warn(
      "expo-notification-service-extension is not supported on web."
    );
    return JSON.stringify({
      configValid: false,
      appGroupAccessible: false,
      cachedAvatarCount: 0,
    });
  }
}

export default registerWebModule(
  ExpoNotificationServiceExtensionModule,
  "ExpoNotificationServiceExtensionModule"
);
